export const getCroppedImg = (imageSrc, cropPixels) => {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.crossOrigin = 'anonymous';
    image.src = imageSrc;

    image.onload = () => {
      const canvas = document.createElement('canvas');
      canvas.width = cropPixels.width;
      canvas.height = cropPixels.height;
      const ctx = canvas.getContext('2d');

      ctx.drawImage(
        image,
        cropPixels.x,
        cropPixels.y,
        cropPixels.width,
        cropPixels.height,
        0,
        0,
        cropPixels.width,
        cropPixels.height
      );

      canvas.toBlob(
        (blob) => {
          if (!blob) {
            reject(new Error('Erro ao gerar imagem.'));
            return;
          }
          const file = new File([blob], 'imagem-cortada.jpg', {
            type: 'image/jpeg',
          });
          resolve(file);
        },
        'image/jpeg',
        1
      );
    };

    image.onerror = () => reject(new Error('Erro ao carregar imagem.'));
  });
};
